export const filterLineData = (data: any[]): any => {
  // Create a set of unique types
  const sources = new Set(data.map((item) => item.source));

  // Create an array of arrays, each containing objects filtered by type
  const groupedData = Array.from(sources).map((source) => {
    return data.filter((item) => item.source === source);
  });

  return groupedData;
};
